export default "__VITE_ASSET__BvOYXWtf__"